interface ItemProps {
  children: ({ isActive }: { isActive?: boolean }) => void;
  isActive?: boolean;
  className?: string;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

const Item = ({ children, isActive, ...passThrough }: ItemProps): JSX.Element => {
  return (
    <li {...passThrough}>
      {children({ isActive })}
      <style jsx>
        {`
          li {
            padding: 0;
          }
        `}
      </style>
    </li>
  );
};

export default Item;
